"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Officer Jane Smith",
  quote: "Since partnering with St. Sampson Foundation, we've seen a significant decline in welfare checks and more engaged seniors.",
  position: "Local Police Department Officer",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590036/img/avatar_jane_smith.png",
  initials: "JS"
}, {
  author: "Mrs. Emily Johnson",
  quote: "The visitation program has brought so much joy and comfort to my mother. We are grateful for this ministry.",
  position: "Senior Caregiver and Family Member",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590036/img/avatar_emily_johnson.png",
  initials: "EJ"
}, {
  author: "Rev. Michael Thompson",
  quote: "This foundation exemplifies Christ’s love through service to the elderly. A true blessing to our community.",
  position: "Orthodox Priest",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590036/img/avatar_michael_thompson.png",
  initials: "MT"
}];
export default function VoicesOfTheCommunity() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}